import { v4 } from 'uuid';
export class UUID { // this class use for generate UUID With https://www.npmjs.com/package/uuid

    constructor() {
    }

    get getUUIDV4() {
       return v4();
    }

}
